import { render, staticRenderFns } from "./PedidosList.vue?vue&type=template&id=18acb798&scoped=true&lang=pug"
import script from "./PedidosList.vue?vue&type=script&lang=js"
export * from "./PedidosList.vue?vue&type=script&lang=js"
import style0 from "./PedidosList.vue?vue&type=style&index=0&id=18acb798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18acb798",
  null
  
)

export default component.exports